import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import VideoCard from "./VideoCard";

export default function VideoRow({ title, accent = "Curated", videos = [], testid = "video-row" }) {
  const scroller = useRef(null);

  if (!videos || videos.length === 0) return null;

  const scroll = (dir) => {
    if (!scroller.current) return;
    scroller.current.scrollBy({ left: dir * 600, behavior: "smooth" });
  };

  return (
    <section data-testid={testid} className="relative px-4 sm:px-8 lg:px-12 py-6 group/row">
      <div className="flex items-end justify-between mb-4">
        <div>
          <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#FFB800]">{accent}</span>
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white tracking-tight">{title}</h2>
        </div>
      </div>
      <div className="relative">
        <button
          aria-label="Scroll left"
          onClick={() => scroll(-1)}
          data-testid={`${testid}-scroll-left`}
          className="hidden md:flex absolute -left-2 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-black/70 border border-white/10 items-center justify-center opacity-0 group-hover/row:opacity-100 transition-opacity hover:border-[#FF6B00] hover:text-[#FFB800]"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <div
          ref={scroller}
          className="flex gap-4 overflow-x-auto scrollbar-hide snap-x scroll-smooth pb-2"
        >
          {videos.map((v) => (
            <div key={v.id} className="snap-start fade-up">
              <VideoCard video={v} />
            </div>
          ))}
        </div>
        <button
          aria-label="Scroll right"
          onClick={() => scroll(1)}
          data-testid={`${testid}-scroll-right`}
          className="hidden md:flex absolute -right-2 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-black/70 border border-white/10 items-center justify-center opacity-0 group-hover/row:opacity-100 transition-opacity hover:border-[#FF6B00] hover:text-[#FFB800]"
        >
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
    </section>
  );
}
